export enum AclSubjectType {
  Team = 'team',
  User = 'user',
  AccessToken = 'api_key',
}

export interface AclSubject {
  subject_type: AclSubjectType;
  subject_id: string;
}
